import React, { useState } from "react";
import { useZxing } from "react-zxing";
import "./FoodMenu.css";

function FoodMenu() {
	console.log("in food menu test!!!");

	const [scanResult, setScanResult] = useState("");
	const [food, setFood] = useState(null);
	const [error, setError] = useState("");
	const api_base_url = process.env.REACT_APP_API_BASE_URL;
	const { ref } = useZxing({
		onDecodeResult(result) {
			const data = result.getText();
			setScanResult(data);

			fetch(`${api_base_url}/main/apiFood/${data}`)
				.then((res) => {
					if (!res.ok) throw new Error("Item not found");
					return res.json();
				})
				.then((json) => {
					setFood(json);
					setError("");
					console.log(food, "food food menu page");

				})
				.catch(() => {
					setFood(null);
					setError("Invalid or missing item in database.");
				});
		},
		//QrCodeImg
		onError(err) {
			console.error(err);
			setError("Camera not accessible or error reading QR.");
		},
	});
	console.log(food, "food food menu page");
	const qrUrl = `${api_base_url}/QrCodeImg`;

	return (
		<div className="App">
			<h1>Food QR Scanner</h1>
			<div className="scanner-container">
				{/* <video ref={ref} style={{ width: "300px" }} /> */}
				<img
					className="table_item_AddImg"
					src={qrUrl}
					alt="QR Code"
				/>
			</div>

			{scanResult && (
				<p>
					Scanned ID: <strong>{scanResult}</strong>
				</p>
			)}

			{food && (
				<div className="food-card">
					{food.image && <img src={food.image} alt={food.name} />}
					<h2>{food.name}</h2>
					<p>Price: ₹{food.price}</p>
				</div>
			)}
			{food && (
				<button
					onClick={() => {
						setFood(null);
						setScanResult("");
					}}
					style={{
						marginTop: "10px",
						padding: "8px 16px",
						borderRadius: "8px",
						background: "#007bff",
						color: "#fff",
						border: "none",
						cursor: "pointer"
					}}
				>
					Scan Another Item
				</button>
			)}

			{error && <p className="error">{error}</p>}
		</div>
	);
}

export default FoodMenu;
